var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:_vm.className},[_c('div',{staticClass:"header__lead"},[_c('TextBlock',{staticClass:"header__lead-text",attrs:{"type":"lead","html":_vm.screen_composition.form_text}},[_vm._t("text")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }